import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('e360')
   .directive('fileDrop', fileDropDirective);

const templateUrl = require('./file-drop.directive.html');

fileDropDirective.$inject = ['$timeout'];
export function fileDropDirective($timeout:ng.ITimeoutService):ng.IDirective {
   return {
      restrict: 'E',
      scope: {
         callbackAdd: '&',
         callbackRemove: '&',
         accepts: '=',
         dropText: '@'
      },
      replace: true,
      templateUrl: templateUrl,
      link: fileDropLink
   };

   function fileDropLink(scope, element:ng.IAugmentedJQuery, attrs) {
      let textDefault = scope.dropText || 'Or drop it here...';

      let fileInput = element.find('input[type=file]');
      let fileButton = element.find('.file-drop-btn');

      scope.dropText = textDefault;
      scope.accepts = scope.accepts || [];
      scope.isInvalid = null;

      scope.onClearFile = clearFile;

      // 'isDraggingFile' is used to set the css of the drag target
      // view so that the styling of the view changes while entering/leaving.
      scope.isDraggingFile = 0;

      // using dom click here instead of ng-click to avoid $apply error
      fileButton.on('click', () => fileInput.click());
      fileInput.on('change', () => setFile(fileInput[0]));

      element.on('dragenter', dragEnterLeave);
      element.on('dragleave', dragEnterLeave);
      element.on('dragover', dragOver);
      element.on('drop', drop);

      function clearFile() {
         scope.callbackRemove();
         scope.file = null;
      }

      function setFile(ele) {
         scope.$apply(() => {
            if (!ele.files || ele.files.length != 1) {
               scope.dropText = 'Error: Only 1 file at a time is allowed.';
               scope.isInvalid = true;
            } else if (!isValidFile(ele.files[0])) {
               scope.dropText = 'Error: You are trying to upload an invalid file type.';
               scope.isInvalid = true;
            } else {
               scope.dropText = textDefault;
               scope.isInvalid = null;
               scope.file = ele.files[0].name;
               scope.fileFormat = ele.files[0].name.split('.').pop();
               scope.callbackAdd({file: ele.files[0]});
            }

            scope.isDraggingFile = 0;
         });
      }

      let dragTimeout;
      function dragEnterLeave(e) {
         e.stopPropagation();
         e.preventDefault();

         scope.$apply(() => {
            // 'isDraggingFile' can't be a boolean because setting it like 
            // 'scope.isDraggingFile = e.type === 'dragenter'' would cause 
            // flicker. This flicker is caused by the fact that we have child 
            // views inside of the main file drop view firing drag events as well.
            // As we only care about the first and last drag event (the main view)
            // we need to keep track of each event.
            scope.isDraggingFile += e.type === 'dragenter' ? 1 : -1;
         });

         if (dragTimeout) {
            $timeout.cancel(dragTimeout);
         }

         dragTimeout = $timeout(() => {
            scope.dropText = textDefault;
            scope.isInvalid = null;
         }, 10);
      }

      // This must be left in even though we aren't using it because
      // without calling 'stopPropagation' and 'preventDefault' on the event,
      // the browser will open the file in a new page instead of setting the file.
      function dragOver(e) {
         e.stopPropagation();
         e.preventDefault();
      }

      function drop(e) {
         e.stopPropagation();
         e.preventDefault();

         setFile(e.originalEvent.dataTransfer);
      }

      function isValidFile(file):boolean {
         return _.any(scope.accepts, (ext:string) => {
            // file name isn't always defined (e.g. during drag-drop)
            if (file.name) {
               let fname = file.name.toLowerCase();
               return endsWith(fname, ext);
            } else {
               return extMimes[ext] && extMimes[ext] === file.type;
            }
         });
      }
   }
}

function endsWith(s:string, suffix:string):boolean {
   return s.indexOf(suffix, s.length - suffix.length) !== -1;
}

const extMimes = {
   ".jpg": 'image/jpeg',
   ".jpeg": 'image/jpeg',
   ".png": 'image/png',
   ".csv": 'text/csv',
   ".xls": 'application/vnd.ms-excel',
   ".xlsx": 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};
